module.exports = __webpack_public_path__ + "static/media/inicio_de_pesquisa.0a999a5b.svg";